// extracted by mini-css-extract-plugin
export default {"pageFormacion":"Page_Formacion_pageFormacion__Lp7SX"};